import { render, staticRenderFns } from "./user-vehicle-form.vue?vue&type=template&id=146a1bc0&scoped=true&"
import script from "./user-vehicle-form.vue?vue&type=script&lang=js&"
export * from "./user-vehicle-form.vue?vue&type=script&lang=js&"
import style0 from "./user-vehicle-form.vue?vue&type=style&index=0&id=146a1bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146a1bc0",
  null
  
)

component.options.__file = "user-vehicle-form.vue"
export default component.exports